import { Component, EventEmitter, Input, Output, Signal, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { BadgeRendererComponent } from '@app/common-codes/components/nested-components/badge/badge-render.component';

@Component({
    selector: 'app-checkin-shell',
    templateUrl: './checkin-shell.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe, BadgeRendererComponent]
})
export class CheckinShellComponent {
    @Input({ required: true }) canNext!: Signal<boolean>;
    @Input({ required: true }) isLastStep!: Signal<boolean>;
    @Input() badgeTemplate?: string;
    @Input() badgeData: any;

    @Output() back = new EventEmitter<void>();
    @Output() forward = new EventEmitter<void>();
    @Output() home = new EventEmitter<void>();
    @Output() save = new EventEmitter<void>();
    @Output() badgeImageReady = new EventEmitter<string>();

    @ViewChild(BadgeRendererComponent) badgeRenderer?: BadgeRendererComponent;

    onGoBack() { this.back.emit(); }
    onGoForward() { this.forward.emit(); }
    onGoHome() { this.home.emit(); }
    onSave() { this.save.emit(); }
    onBadgeImageReady(base64: string) { this.badgeImageReady.emit(base64); }
}
